import React, {useEffect, useState} from 'react';
import {connect, useSelector} from 'react-redux';
import {Route, useLocation} from 'react-router-dom';
import {createStructuredSelector} from 'reselect';

import Header from '../../components/Layout/Header/Header';
import Menu from '../../components/Menu/Menu';
import * as authScreenNames from '../../consts/auth/authScreenNames';
import {MAP_PAGE} from '../../consts/route/routePaths';
import {USER} from '../../consts/user/userRolesId';
import appRouterService from '../../services/app/appRouterService';
import authDataStoreService from '../../services/auth/authDataStoreService';
import currentUserService from '../../services/user/currentUserService';
import {makeSelectAuthToken} from '../../state/selectors/auth';
import {makeSelectCurrentUserInfo} from '../../state/selectors/currentUser';
import {makeIsDemoView} from '../../state/selectors/global';
import DrawersRoot from '../Drawers/DrawersRoot';
import LoaderGlobal from '../LoaderGlobal/LoaderGlobal';
import ModalsRoot from '../Modals/ModalsRoot';
import Notifications from '../Notifications/Notifications';

const mapStateToProps = createStructuredSelector({
    isDemoView: makeIsDemoView(),
    authToken: makeSelectAuthToken(),
});

const AppLayout = (props) => {
    const {component: Component, path, isDemoView, authToken} = props;
    const {pathname} = useLocation();
    const [isMobileMenuOpened, setIsMobileMenuOpened] = useState(false);

    const isUserHaveAccess = isDemoView || authToken;

    const currentUserInfo = useSelector(makeSelectCurrentUserInfo());

    const {roleId, id} = currentUserInfo || {};

    const isUser = roleId === USER;

    const getInitialData = async () => {
        const {id} = authDataStoreService.parseJWTFromStorage();

        await currentUserService.getCurrentUserInfoById({id});
    };

    useEffect(() => {
        if (isUserHaveAccess) return;

        if (pathname?.includes(authScreenNames.REGISTRATION)) {
            return appRouterService.forwardToAuthPage(authScreenNames.REGISTRATION);
        }
        appRouterService.forwardToAuthPage();
    }, []);

    useEffect(() => {
        if (!authToken) return;
        getInitialData();
    }, [authToken]);

    useEffect(() => {
        if (isUserHaveAccess && isUser) {
            currentUserService.getCurrentUserResponsibilitiesListByIdWithData({userID: id});
        }
    }, [isUser, isUserHaveAccess]);

    useEffect(() => {
        setIsMobileMenuOpened(false);
    }, [pathname]);

    useEffect(() => {
        if (!isMobileMenuOpened) return undefined;

        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                setIsMobileMenuOpened(false);
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [isMobileMenuOpened]);

    return (
        <Route
            path={path}
            render={(matchProps) => (
                <>
                    <Notifications />
                    <DrawersRoot />
                    <ModalsRoot />
                    <LoaderGlobal />
                    {isUserHaveAccess ? (
                        <div className='app-layout flex flex-col items-center relative bg-wild_sand font-inter min-h-screen'>
                            <Header
                                isMobileMenuOpened={isMobileMenuOpened}
                                onMobileMenuClick={() => setIsMobileMenuOpened((isOpened) => !isOpened)}
                            />
                            <div
                                className={`app-layout-main flex flex-1 w-full${
                                    pathname === MAP_PAGE ? ' app-layout-main-map' : ''
                                }`}
                            >
                                <Menu
                                    isMobileMenuOpened={isMobileMenuOpened}
                                    onMobileMenuClose={() => setIsMobileMenuOpened(false)}
                                />
                                <Component {...matchProps} />
                            </div>
                        </div>
                    ) : (
                        <Component {...matchProps} />
                    )}
                </>
            )}
        />
    );
};

export default connect(mapStateToProps)(AppLayout);
